import calculateTotalSavings from "../savings/objects/calculate_total_savings";
import addToSummaryArr from "./add_to_summaryArr";

export const calcSavingsSummary=(savingsArr, savingsClass, summaryArr, gameNbrMonths) => {
    const savingsTotals = calculateTotalSavings(savingsArr, gameNbrMonths, savingsClass);
    
    let totalSavingsArr = savingsTotals.totalSavingsArr;
    for (let i=0; i<totalSavingsArr.length; i++){
        const savings = totalSavingsArr[i];
        const totalInitialValue = +savings.totalDeposit + +savings.totalTransferAmt;
        let totalCurrentValue = +savings.totalSavings + +savings.totalTransferAmt;
        if (savingsClass === "retirement"){
            totalCurrentValue = +savings.totalBeforeMatchAmt + +savings.totalTransferAmt;
        }
        addToSummaryArr(savingsClass, savings.savingsType, totalInitialValue, totalCurrentValue, summaryArr);
        if (savingsClass === "retirement"){
            const totalInitialValue = +savings.totalMatchDeposits;;
            const totalCurrentValue = (+savings.totalMatchAmt).toFixed(2);
            addToSummaryArr("401KMatch", savings.savingsType,
                +totalInitialValue, totalCurrentValue, summaryArr);
            addToSummaryArr("401KMatch", "", totalInitialValue, totalCurrentValue, summaryArr);
            addToSummaryArr("Total Amounts", "", totalInitialValue, totalCurrentValue, summaryArr);
        }
    }
    if (totalSavingsArr.length > 0){
        let totalInitialValue = +savingsTotals.totalDeposited + +savingsTotals.totalTransferAmt;
        let totalCurrentValue = +savingsTotals.totalSavings;
        if (savingsClass === "retirement"){
            totalCurrentValue = +savingsTotals.totalBeforeMatchAmt + savingsTotals.totalTransferAmt;
        }
        addToSummaryArr(savingsClass, "", totalInitialValue, totalCurrentValue, summaryArr);
        addToSummaryArr("Total Amounts", "", totalInitialValue, totalCurrentValue, summaryArr);
    }
}
export default calcSavingsSummary;